import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {//state
    lang: "zh",
    apiBasePath: "https://www.mrtlab.com/api/" ,// 统一使用HTTPS  //要设置的初始属性值
    //apiBasePath: "http://127.0.0.1:8080/api/",  //要设置的初始属性值
    dialogLoginVisible: false,
    dialogRegisterVisible: false,
  },

  mutations: {
    login_dialog(state) {//这里的state对应着上面这个state
      state.dialogLoginVisible = !state.dialogLoginVisible;
      //你还可以在这里执行其他的操作改变state
    },
    register_dialog(state) {//这里的state对应着上面这个state
      state.dialogRegisterVisible = !state.dialogRegisterVisible;
      //你还可以在这里执行其他的操作改变state
    },
    langUpdate(state, value) {
      state.lang = value
    }
  }

});

export default store;





// WEBPACK FOOTER //
// ./src/store/index.js